import _ from 'lodash'

export default {
  listCommit (state, data) {
    state.list = data

    state.listOptions = _.map(data, function (e) {
      return { id: e.id, value: e.id, text: e.username, label: e.username }
    })
  }
}
